import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@material-ui/core/SvgIcon/SvgIcon";
import React from "react";
import pure from "recompose/pure";

const ExpandPolygonIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 8 5" fill="none" >
    <path d="M4.39042 4.51196C4.19026 4.76216 3.80972 4.76216 3.60955 4.51196L0.649867 0.812348C0.387961 0.484966 0.621048 6.45088e-07 1.0403 6.08436e-07L6.95968 9.0948e-08C7.37893 5.42957e-08 7.61202 0.484966 7.35011 0.812347L4.39042 4.51196Z" fill="#2B3940" />
  </SvgIcon>
);
ExpandPolygonIcon.displayName = "ExpandPolygonIcon";
ExpandPolygonIcon.muiName = "SvgIcon";

export default pure(ExpandPolygonIcon);